module.exports = __webpack_public_path__ + "img/andar.f8a4ba13.png";